import {
	CriteriaModifierType,
	CriteriaType,
	OwnershipType,
	RuleDTO,
	RuleStatus
} from 'api-models'
import { ClickStatus } from 'api-models/dist/advertiser/click'
import { LevelType } from 'layout/navbar/breadcrumbs/types'

export const prepareQuery = (
	level: LevelType,
	asset_id?: string,
	targetId?: string | null
) => {
	if (level === 'website') {
		return {
			asset_id,
			ownership: OwnershipType.WEBSITE
		}
	}

	if (level === 'ad-account') {
		return {
			ad_account_id: targetId,
			ownership: OwnershipType.AD_ACCOUNT
		}
	}

	return {
		campaign_id: targetId,
		ownership: OwnershipType.CAMPAIGN
	}
}

export const mapFetchedRules = (rules: RuleDTO[]) => {
	return rules
		.filter((rule) => rule.status !== RuleStatus.DELETED)
		.map((rule) => ({
		id: rule.id,
		ownership: rule.ownership,
		ad_account_id: rule.ad_account_id,
		campaign_id: rule.campaign_id,
		name: rule.name,
		description: rule.description,
		enabled: rule.status === RuleStatus.ACTIVE,
		trigger: {
			scope: rule.scope.type,
			scope_values: rule.scope.values || [],
			focus: rule.focus.source,
			max_ad_clicks: rule.criteria.value,
			period_value: rule.criteria.period.value,
			period_type: rule.criteria.period.unit
		},
		threshold: {
			type:
				rule.criteria.type === CriteriaType.SOURCE_FREQ ? 'all' : 'percentage',
			percentage_value: rule.criteria.share_value
		},
		modifiers: rule.criteria.modifiers.map((m) => {
			if (m.type === CriteriaModifierType.CONVERSION) {
				if (m.conversion?.negative)
					return { ...m, type: CriteriaModifierType.NOT_CONVERSION }

				const mode = m.conversion?.label ? 'with label' : 'all'
				return { ...m, conversion: { ...m.conversion, negative: false, mode } }
			}
			if (m.type === CriteriaModifierType.IP_USAGE) {
				return {
					...m,
					ip_usage: {
						negative: !!m.ip_usage?.negative,
						values: mapIpUsageValues(m.ip_usage?.values)
					}
				}
			}
			if (m.type === CriteriaModifierType.TIME) {
				const negative = m.time?.operand === 'less'
				return {
					...m,
					time: {
						...m.time,
						primary: {
							value: m.time?.primary.value || 0,
							unit: m.time?.primary.unit || 'second'
						},
						negative
					}
				}
			}
			if (m.type === CriteriaModifierType.PAGE_VIEWS) {
				const negative = m.page_views?.operand === 'less'
				return {
					...m,
					page_views: {
						...m.page_views,
						primary: m.page_views?.primary || 0,
						negative
					}
				}
			}
			return m
		}),
		resolve_status: rule.resolve_status || ClickStatus.GOOD,
		resolve_labels: {
			enabled: rule.actions.labels && rule.actions.labels?.length > 0,
			labels: rule.actions.labels
		},
		block: rule.actions.block,
		temp_ip_exclusion: rule.actions.temp_ip_exclusion || null,
		audience_exclusion: !!rule.actions.audience_exclusion
	}))
}

const mapIpUsageValues = (values: any) => {
	return values.map((v: string) => {
		if (v === 'hosting') return 'Data center'
		if (v === 'corporate') return 'Business'
		if (v === 'consumer') return 'Residential'
	})
}
